import { render, staticRenderFns } from "./Prochainement.vue?vue&type=template&id=dfbf76b2&"
import script from "./Prochainement.vue?vue&type=script&lang=js&"
export * from "./Prochainement.vue?vue&type=script&lang=js&"
import style0 from "./Prochainement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports